import * as z from "zod";

export const salesChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
});
